const colorMap = {
  // Primary and secondary colors.
  Navy: `primary.dark-blue`,
  'Froneri Blue': `primary.froneri-blue`,
  Pink: `secondary.pink`,
  Orange: `secondary.orange`,
  Green: `secondary.green`,
  Yellow: `secondary.yellow`,
  'Light Grey': `secondary.light-grey`,
  White: `white`,
  NavyBlue: `secondary.navy-blue`,
  // Brand colors.
  Oreo: `brand.oreo`,
  'Drumstick & Extrême': `brand.extreme`,
  Nuii: `brand.nuii`,
  'Häagen-Dazs': `brand.haagen-dazs`,
  'Outshine & Rowntree': `brand.outshine`,
  "Cadbury's": `brand.cadburys`,
  Dreyers: `brand.dreyers`,
  'Dreyers Alt': `brand.dreyers-alt`,
  'Skinny Cow': `brand.skinny-cow`,
  'Skinny Cow Alt': `brand.skinny-cow-alt`,
  Aino: `brand.aino`,
  Fazer: `brand.fazer`,
  PINGVIININ: `brand.pingviinin`,
  Milka: `brand.milka`,
  'Milka (Dark)': `brand.milka-dark`,
  'La Laitiere': `brand.la-laitiere`,
  Maxibon: `brand.maxibon`,
  KITKAT: `brand.kitkat`,
  'La lechera': `brand.la-lechera`,
  Antica: `brand.antica`,
  'Zielona Budka': `pl.zielona-budka'`,
  Kaktus: `pl.kaktus`,
  'Kaktus 2': `pl.kaktus-2'`,
  'KitKat 2': `pl.kitkat`,
  'Lotus Biscoff': `brand.lotus`,
  'Mälzer & Fu': `brand.malzer`,
  Lion: `pl.lion`,
  'Lion 2': `pl.lion-2'`,
  Nesquik: `pl.nesquik`,
  'Nesquik 2': `pl.nesquik-2'`,
  Movenpick: `pl.movenpick`,
  Daim: `pl.daim`,
  'Daim 2': `pl.daim-2'`,
  'Daim 3': `fi.daim`,
  Nestea: `pl.nestea`,
  'After Eight': `pl.after-eight'`,
  'After Eight 2': `pl.after-eight-2'`,
  'Forest Awakening': `fi.forest-awakening`,
  'Golden Serenity': `fi.golden-serenity`,
  'Mystic Uplift': `fi.mystic-uplift`,
  'DarkBlue': `fi.dark-blue`
};

/* Designed to replace the getTextColour method for more
 * levels of control for each component. Could be extended
 * to replicate getTextColour and avoid breakages. */
const componentColourMap = {
  'fi.forest-awakening': {
    'half-and-half': `fi.mystic-uplift`,
    'media-and-text': `fi.golden-serenity`
  },
  'fi.daim': {
    'media-and-text': `fi.dark-blue`,
  }
};

export const getColourFromComponentMap = (componentName, value) => {
  if (typeof componentName === `undefined` || componentName === null) {
    return null;
  }

  const colourMapRoot = componentColourMap[value];

  if (typeof colourMapRoot === `undefined` || colourMapRoot === null) {
    return null;
  }

  const colourMatch = colourMapRoot[componentName] || null;

  return colourMatch;
};

/**
 * A helper function that determines the Chakra UI color to use based on a CMS field value.
 * @param {string} value The CMS field value.
 * @returns {string} The Chakra UI color to use.
 */
export const getColorFromField = (value) => {
  return colorMap[value];
};

export default getColorFromField;
